<template>
    <div>
        <div class="main">
            <div class="nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
									<el-breadcrumb-item :to="{ path: '/mechanicalEquipment' }">机械设备</el-breadcrumb-item>
									<el-breadcrumb-item>设备退场</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
						<div class="cont">
							<div class="search">
								<div class="search-l">
									<div class="input"><el-input @change="getData" clearable v-model="searchList.equipName" placeholder="请输入设备名称"></el-input></div>
									<div class="input"><el-input @change="getData" clearable v-model="searchList.sn" placeholder="请输入设备序列号"></el-input></div>
									<div class="btn" @click="getData">搜索</div>
								</div>
								<div class="search-r">
									<div class="btn" @click="exportOut">导出表单</div>
								</div>
							</div>
							<el-table
								:data="dataList"
								height="70vh"
								style="width: 100%">
								<el-table-column
									label="序号"
									width="90">
									<template slot-scope="scope">
										{{(pageNum-1)*pageSize+scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column
									prop="equipName"
									label="设备名称"
									>
								</el-table-column>
								<el-table-column
									prop="sn"
									label="序列号"
									>
								</el-table-column>
								<el-table-column
									prop="specifications"
									label="型号规格"
									>
								</el-table-column>
								<el-table-column
									prop="installationUnit"
									label="安装单位"
									>
								</el-table-column>
								<!-- <el-table-column
									prop="testingUnit"
									label="检测单位"
									>
								</el-table-column> -->
								<el-table-column
									prop="location"
									label="安装位置"
									>
									<template slot-scope="scope">
										<div v-show="scope.row.location.lat">
											东经：{{scope.row.location.lat}} </br>北纬：{{scope.row.location.lng}}
										</div>
									</template>
								</el-table-column>

								<el-table-column
									prop="createDate"
									label="进场时间"
									>
								</el-table-column>
								<el-table-column
									prop="updateDate"
									label="退场时间"
									>
								</el-table-column>
							</el-table>
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageNum"
								:page-sizes="[10,20, 40, 80, 100]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="total"
								>
							</el-pagination>
						</div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
    export default {
        data() {
					return {
						dataList: [],
						searchList:{
						projectId:'',
						sn:'',
						delFlag:'1', // 进出场
						equipType:'1',
						equipName:'',
					},
					pageSize:10,
					pageNum:1,
					}
				},
				mounted(){
					this.searchList.projectId = util.session.get('groupId')
					this.getData()
				},
				methods:{
					exportOut(){
						let accessToken = this.$store.state.token
						let projectId = util.session.get('groupId')
						let delFlag = '1'
						let equipType = '1'
						let sn = this.searchList.sn
						let equipName  =this.searchList.equipName
						window.open(
							myHttp.exportInMechine + 
							'?projectId='+
							projectId +
							'&delFlag=' + 
							delFlag +
							'&equipType=' +
							equipType +
							'&accessToken=' +
							accessToken +
							'&sn=' +
							sn +
							'&equipName='+
							equipName
						)
					},
						handleSizeChange(val){
						this.pageSize = val
						this.pageNum = 1
						this.getData()
					},
					handleCurrentChange(val){
						this.pageNum = val
						this.getData()
					},
					getData(){
						this.searchList.pageSize =  this.pageSize
						this.searchList.pageNum =  this.pageNum
						myHttp.getDistributionPageNew(this.searchList).then(res=>{
							console.log(res)
							if(res.data.code === 200){
								this.dataList = res.data.data.distribution.list
								this.total = res.data.data.distribution.total
								this.dataList.forEach((item,index)=>{
									this.dataList[index].location = JSON.parse(item.location)
									console.log(item.location)
								})
							}
						})

					},
				}
    }
</script>

<style  scoped>
.main{
    height: 90.4vh;
    background-color: #F3F8FC;
    padding: 0 1% 0 0.5%;
}
.nav{
    height: 60px;
		display: flex;
		align-items: center;
}
.el-breadcrumb{
	font-size: 20px;
}
.cont{
	background-color: #fff;
	height: 82vh;
	border-radius: 6px;
	overflow: hidden;
}
.search{
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.btn{
	width: 100px;
height: 40px;
background: #0B62F0;
border-radius: 6px;
display: flex;
justify-content: center;
align-items: center;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
.btn:hover{
	cursor: pointer;
	opacity: 0.7;
}
.input{
	width: 200px;
height: 40px;
}
.search-l{
	margin-left: 10px;
	display: flex;
	width: 520px;
	justify-content: space-between;
}
.search-r{
	display: flex;
	width: 320px;
	justify-content: end;
	margin-right: 10px;
}
::v-deep .el-table th{
	background-color: #E6E6E6 !important;
}
.el-pagination{
	background-color: #E6E6E6 ;
}
</style>